const isElementOverflowing = ({ clientHeight, scrollHeight }: HTMLElement) => {
  return scrollHeight > clientHeight
}

export default isElementOverflowing
